import styled, { css } from 'styled-components';

const ResizeBorderHorizontal = styled.div<{ isDragging: boolean }>`
  width: 100%;
  height: 1px;
  position: absolute;
  top: 0;

  &:hover {
    cursor: row-resize;
    height: 10px;
    background-color: #f3e9d7;
  }
  ${props =>
    props.isDragging &&
    css`
      cursor: row-resize;
      height: 10px;
      background-color: #f3e9d7;
    `}
`;
ResizeBorderHorizontal.displayName = 'ResizeBorderHorizontal';

const ResizeBorderVertical = styled.div<{
  isDragging: boolean;
  position: 'left' | 'right';
}>`
  height: 100%;
  width: 1px;
  position: absolute;
  ${props => (props.position === 'left' ? 'left' : 'right')}: 0;

  &:hover {
    cursor: col-resize;
    width: 10px;
    background-color: #f3e9d7;
  }
  ${props =>
    props.isDragging &&
    css`
      cursor: col-resize;
      width: 10px;
      background-color: #f3e9d7;
    `}
`;
ResizeBorderVertical.displayName = 'ResizeBorderVertical';

export { ResizeBorderHorizontal, ResizeBorderVertical };
